export const plans = [
  {
    id: 'free-trial',
    name: 'Free Trial',
    sub: '14 Days',
    segment: 'First time only',
    isTrial: true,
    featured: false,
    credits: 1000,
    bus: 1,
    priceIn: { monthly: 0, annual: 0, worth: 1000 },
    priceUs: { monthly: 0, annual: 0, worth: 11 },
    extraBu: { in: 500, us: 6 },
    tagline: 'Every feature unlocked, no card required.',
  },
  {
    id: 'marvel',
    name: 'Marvel',
    sub: 'Spark',
    segment: 'Solo / freelancer',
    featured: false,
    credits: 2200,
    bus: 1,
    priceIn: { monthly: 1800, annual: 19008 },
    priceUs: { monthly: 22, annual: 232 },
    extraBu: { in: 500, us: 6 },
    tagline: 'For solo operators and freelancers getting started.',
  },
  {
    id: 'growth',
    name: 'Growth',
    sub: 'Boost',
    segment: 'Growing individual',
    featured: false,
    credits: 5000,
    bus: 2,
    priceIn: { monthly: 4499, annual: 47509 },
    priceUs: { monthly: 55, annual: 581 },
    extraBu: { in: 750, us: 9 },
    tagline: 'For a growing individual practice or small team.',
  },
  {
    id: 'opal',
    name: 'Opal',
    sub: 'Starter',
    segment: 'Small clinics / SMB',
    featured: true,
    credits: 10500,
    bus: 3,
    priceIn: { monthly: 8100, annual: 85536 },
    priceUs: { monthly: 99, annual: 1045 },
    extraBu: { in: 1000, us: 12 },
    tagline: 'For small clinics, firms and SMBs scaling up.',
  },
];
